import {
    forwardRef,
    useContext,
} from "react"

import AddressFields from "../AddressFields"

import ApplicantDataFormContext from "../../Contexts/ApplicantDataFormContext"

const CurrentAddress = forwardRef(({ title, data, readOnly }, ref) => {

    const applicantDataForm = useContext(ApplicantDataFormContext)

    const locationOfResidence = applicantDataForm?.current?.["locationOfResidence"]

    return (
        <AddressFields title={title} ref={ref} data={data || locationOfResidence} readOnly={readOnly} />
    )

})

export default CurrentAddress
